'use strict';

var _ = require('lodash');

/**
 * Checks if isiOS
 * @returns {boolean} Returns true if isiOS
 */
function isiOS() {
    return !!(navigator.userAgent.match(/iPad|iPhone/i));
}

/**
 * Checks if the browser is Chrome
 * @returns {boolean} Returns true if  he browser is Chrome
 */
function isChrome() {
    return (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
}

/**
 * Checks if the browser is IE
 * @returns {boolean} Returns true if  he browser is IE
 */
function isIE() {
    return (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || !!navigator.userAgent.match(/Trident.*rv:11\./));
}

/**
 * Add backdrop
 */
function addBackdrop(settings) {
    var offsetTop = settings.offsetTop || 0;
    var specificClass = settings.specificClass || '';

    var $body = $('body');
    var backDrop = '<div class="modal-backdrop ' + specificClass + ' fade show"></div>';

    if ($body.find('.modal-backdrop').length === 0) {
        $body.append(backDrop);
        var $addedBackdrop = $body.find('.modal-backdrop');

        $addedBackdrop.css('top', offsetTop);
    }
}

/**
 * Remove backdrop
 */
function removeBackdrop(customClass) {
    var $body = $('body');
    var $modalBackDrop = $body.find('.modal-backdrop');

    if (customClass) {
        $modalBackDrop = $body.find('.' + customClass);
    }

    if ($modalBackDrop.length > 0) {
        $modalBackDrop.remove();
    }
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] == undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function trapFocusInsideModal(element) {

    if (!element) return;

    var $focusableElements = $(element).find(`
    a[href]:not([disabled]),
    button:not([disabled]),
    textarea:not([disabled]),
    input[type="text"]:not([disabled]),
    input[type="radio"]:not([disabled]),
    input[type="checkbox"]:not([disabled]),
    select:not([disabled]),
    [role="button"]
`);
    if ($focusableElements.length > 0) {
        var firstFocusableElement = $focusableElements[0];
        var lastFocusableElement = $focusableElements[$focusableElements.length - 1];
        firstFocusableElement.focus();

        var TABKEYCODE = 9;

        var focusHandler = function (event) {
            var tabPress = event.which === TABKEYCODE || event.key === 'Tab';

            if (!tabPress) {
                return;
            }
            if (event.shiftKey && document.activeElement === firstFocusableElement) {
                if (lastFocusableElement) {
                    lastFocusableElement.focus();
                }
                event.preventDefault();
            } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
                if (firstFocusableElement) {
                    firstFocusableElement.focus();
                }
                event.preventDefault();
            }
        };
    }

    element.addEventListener('keydown', focusHandler);

    // Unsubscribe function
    return () => element.removeEventListener('keydown', focusHandler);
}

function scrollToHash() {
    history.scrollRestoration = 'auto';

    if (window.location.hash) {
        var hash = window.location.hash;
        history.scrollRestoration = 'manual';
        if ($(hash).length) {
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 0);
        }
    }
}


/**
 * Set cookie
 * @param {string} cname - Cookie name
 * @param {string} cvalue - Cookie value
 * @param {integer} exdays - Expiration days
 */
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * Get cookie
 * @param {string} cname - cookie name
 */
function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

/**
 * Get parameter by name
 * @param {string} name - param name
 */
function getParameterByName(name) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get(name);
}

/**
 * Find value in object
 * @param {object} object - object to search
 * @param {string} value - value to be searched in the object
 */
function findValueInObject(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

/**
 * Used to count the remaining characters in an input
 */
function charactersCount() {
    var updateCounter = function ($input) {
        var maxlength = $input.attr('maxlength');
        var currentChars = $input.val().length;
        var textBetween = $input.data('show-char-count');
        var template = `<p class="characters-count bbw-text-right">
                    <span class="characters-rest">${maxlength - currentChars}</span>
                    ${textBetween}
                    <span class="characters-rest">${maxlength}</span>
                </p>`;
        var $charCountContainer = $input.parent().find('.js-char-counter');
        $charCountContainer.html(template);
    };

    $(document).on('input', '[data-show-char-count]', _.debounce(function () {
        var $input = $(this);
        updateCounter($input);
    }, 200));

    $('[data-show-char-count]').each(function (i, input) {
        updateCounter($(input));
    });
}

module.exports = {
    isiOS: isiOS,
    isChrome: isChrome,
    isIE: isIE,
    addBackdrop: addBackdrop,
    removeBackdrop: removeBackdrop,
    isTouchDevice: isTouchDevice,
    getUrlParameter: getUrlParameter,
    trapFocusInsideModal:trapFocusInsideModal,
    scrollToHash: scrollToHash,
    setCookie: setCookie,
    getCookie: getCookie,
    getParameterByName: getParameterByName,
    findValueInObject: findValueInObject,
    charactersCount: charactersCount
};
